<template>
    <div
        class="kgr-accordion__item kgr-region kgr-region--lightGray kgr-region--rounded"
        :class="{ 'is-open': isOpen }"
    >
        <div
            class="kgr-accordion__itemHeader"
            @click="toggle"
        >
            <div class="kgr-accordion__itemHeaderLeft">
                <template v-if="$slots.headerHeadline">
                    <slot name="headerHeadline"></slot>
                </template>
                <template v-else>
                    <span
                        class="kgr-accordion__itemHeadline"
                        :class="{ 'kgr-color kgr-color--error': hasError }"
                    >
                        {{ title }}
                    </span>
                </template>
                <slot name="header-left"></slot>
            </div>
            <div class="kgr-accordion__itemHeaderRight">
                <slot name="header-right"></slot>
                <kgr-icon
                    icon-class="arrow-right"
                    class="kgr-accordion__itemIcon"
                />
            </div>
        </div>
        <div
            class="kgr-collapsible"
            :class="{ 'is-open': isOpen, 'kgr-collapsible--overflow': overflow }"
        >
            <div class="kgr-accordion__itemContent kgr-collapsible__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '../icon/Icon.vue';

export default {
    components: { 'kgr-icon': Icon },
    props: {
        title: {
            type: String,
            required: false,
        },
        open: {
            type: Boolean,
            required: false,
            default: false,
        },
        overflow: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.open,
        };
    },
    watch: {
        open(newVal) {
            this.isOpen = newVal;
        },
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$emit('opened');
            } else {
                this.$emit('closed');
            }
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
